import * as React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import LayerRow from './LayerRow';
import Layer from '../data/Layer';

const SortableRow = SortableElement(LayerRow);

interface Props {
  items: Layer[];
  onAddFilter: (layer: Layer, domElement: HTMLElement) => void;
  getPlaybackPosition: () => number;
  layerToAddFilter: Layer | null;
  onAddEffectSelect: (id: string, data: any) => void;
  disabled: boolean;
  isEditingTimeline: boolean;
}

export default class extends React.Component<Props> {
  layerToExpand: HTMLElement;
  render() {
    return (
      <div>
        {this.props.items.map((layer: Layer, index: number) => {
          const pickEffect = layer === this.props.layerToAddFilter;
          return (
            <SortableRow
              data={layer}
              key={layer.id}
              index={index}
              onAddFilter={this.props.onAddFilter}
              getPlaybackPosition={this.props.getPlaybackPosition}
              pickEffect={pickEffect}
              onAddEffectSelect={this.props.onAddEffectSelect}
              disabled={this.props.disabled || pickEffect}
              isEditingTimeline={this.props.isEditingTimeline}
            />
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/LayersList.tsx